export default "__VITE_ASSET__CeYCsZ2B__ 100w";